var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoteTab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19696_35778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 1.88672H5.00016C4.55814 1.88672 4.13421 2.06231 3.82165 2.37487C3.50909 2.68743 3.3335 3.11136 3.3335 3.55339V16.8867C3.3335 17.3287 3.50909 17.7527 3.82165 18.0652C4.13421 18.3778 4.55814 18.5534 5.00016 18.5534H15.0002C15.4422 18.5534 15.8661 18.3778 16.1787 18.0652C16.4912 17.7527 16.6668 17.3287 16.6668 16.8867V6.88672M11.6668 1.88672L16.6668 6.88672M11.6668 1.88672V6.88672H16.6668M13.3335 11.0534H6.66683M13.3335 14.3867H6.66683M8.3335 7.72005H6.66683",
    stroke: "#475467",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19696_35778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.220703)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteTab);
export default __webpack_public_path__ + "static/media/noteTab.73611ff1f43d06f009bd3b8871e51fa9.svg";
export { ForwardRef as ReactComponent };